import { useState } from "react"
import { FiX, FiCalendar, FiCheck } from "react-icons/fi"
import {createCalendarEvent} from "@/lib/api-chatbot-client";

export function CalendarModal({ isPlan, setIsPlan, eventTitle, setEventTitle, selectedDate, setSelectedDate, sessionId }) {
    const [loading, setLoading] = useState(false)
    if (!isPlan) return null

    const canValidate = selectedDate && eventTitle

    const handleValidate = async () => {
        if (!canValidate) return

        setLoading(true)
        try {
            await createCalendarEvent(selectedDate, eventTitle, sessionId)
            alert("Événement ajouté ✅")
            setSelectedDate("")
            setEventTitle("")
            setIsPlan(false)
        } catch (err) {
            alert("Erreur lors de l'ajout ❌")
            console.error(err)
        } finally {
            setLoading(false)
        }
    }

    return (
        <div
            className="fixed inset-0 z-[60] flex items-center justify-center bg-black/50 p-4 backdrop-blur-sm animate-in fade-in duration-200"
            onClick={() => setIsPlan(false)}
        >
            <div
                className="w-full max-w-md overflow-hidden rounded-2xl border border-border bg-card shadow-2xl animate-in zoom-in-95 slide-in-from-bottom-4 duration-200"
                onClick={(e) => e.stopPropagation()}
            >
                {/* En-tête */}
                <div className="flex items-center justify-between border-b border-border bg-gradient-to-r from-primary to-[#FFD133] px-5 py-4">
                    <div className="flex items-center gap-2.5">
                        <div className="flex h-9 w-9 items-center justify-center rounded-full bg-white/25">
                            <FiCalendar className="h-5 w-5 text-white" />
                        </div>
                        <h3 className="font-poppins text-base font-semibold text-white">Planifier un entraînement</h3>
                    </div>
                    <button
                        onClick={() => setIsPlan(false)}
                        aria-label="Fermer"
                        className="flex h-8 w-8 items-center justify-center rounded-lg text-white/80 transition-colors hover:bg-white/20 hover:text-white"
                    >
                        <FiX className="h-5 w-5" />
                    </button>
                </div>

                {/* Corps */}
                <div className="space-y-4 p-5">
                    <div className="space-y-1.5">
                        <label className="text-xs font-medium text-muted-foreground">Titre de l'événement</label>
                        <input
                            type="text"
                            placeholder="Ex : Séance coaching..."
                            value={eventTitle}
                            onChange={(e) => setEventTitle(e.target.value)}
                            className="input-ios h-10 w-full rounded-lg border border-input bg-background px-3 text-sm text-foreground placeholder:text-muted-foreground focus:border-primary focus:outline-none focus:ring-2 focus:ring-primary/30"
                        />
                    </div>

                    <div className="space-y-1.5">
                        <label className="text-xs font-medium text-muted-foreground">Date</label>
                        <input
                            type="date"
                            value={selectedDate}
                            onChange={(e) => setSelectedDate(e.target.value)}
                            className="input-ios h-10 w-full rounded-lg border border-input bg-background px-3 text-sm text-foreground focus:border-primary focus:outline-none focus:ring-2 focus:ring-primary/30"
                        />
                    </div>

                    <div className="flex justify-end gap-2 pt-2">
                        <button
                            onClick={() => setIsPlan(false)}
                            className="h-9 rounded-lg border border-input bg-background px-4 text-sm font-medium text-foreground transition-colors hover:bg-accent"
                        >
                            Annuler
                        </button>
                        <button
                            onClick={handleValidate}
                            disabled={!canValidate || loading}
                            className="flex h-9 items-center gap-1.5 rounded-lg bg-primary px-4 text-sm font-medium text-white shadow-sm transition-colors hover:bg-primary/90 disabled:cursor-not-allowed disabled:opacity-50"
                        >
                            <FiCheck className="h-4 w-4" />
                            {loading ? "..." : "Valider"}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}